export const house = {
  house: {
    shape:
      '<path fill="#000" fill-opacity=".51" d="M5 20v-9.15l-1.925 1.5-.625-.8L5 9.6V6.95h1v1.875l6-4.575 9.55 7.3-.625.8L19 10.85V20H5Zm1-1h4.625v-4.775h2.75V19H18v-8.9l-6-4.575L6 10.1V19ZM5 5.775c0-.6.192-1.117.575-1.55.383-.433.933-.65 1.65-.65.433 0 .746-.117.938-.35.191-.233.287-.517.287-.85h1c0 .617-.192 1.137-.575 1.562-.383.425-.933.638-1.65.638-.433 0-.746.117-.938.35a1.297 1.297 0 0 0-.287.85H5Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
